import { Checkbox, Form } from 'antd'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { POSTAL_PROCURATION_CONFIRMATION } from '../mutation'
import { useMutation } from '@apollo/client'
import { Domiciliation } from 'globals/models/Domiciliation'
import popupSuccess from 'globals/popupSuccess'
import { displayErrors } from 'globals/graphql'

interface BelgiumPPConfirmationProps {
  domiciliation: Domiciliation
}

const BelgiumPPConfirmation = ({ domiciliation }: BelgiumPPConfirmationProps) => {
  const { t } = useTranslation()
  const [confirmPostalProcuration, { loading }] = useMutation(POSTAL_PROCURATION_CONFIRMATION, displayErrors)

  const onFinish = (values: any) => {
    confirmPostalProcuration({
      variables: {
        domiciliationId: domiciliation.id,
        withTampon: values.confirm
      }
    }).then(() => popupSuccess(t('clients.actions.postal_procuration_confirmation_success')))
  }

  const initialValues = {
    confirm: domiciliation.postalProcurationReady
  }

  return (
    <BelgiumPPConfirmationWrapper>
      <Form name='belgiumPP' onFinish={onFinish} initialValues={initialValues}>
        <Form.Item name='confirm' valuePropName='checked'>
          <Checkbox>{t('clients.actions.postal_procuration_confirmation')}</Checkbox>
        </Form.Item>
        <Form.Item>
          <PostalProcurationButton type='submit' disabled={loading}>
            {t('global.register')}
          </PostalProcurationButton>
        </Form.Item>
      </Form>
    </BelgiumPPConfirmationWrapper>
  )
}

export const BelgiumPPConfirmationWrapper = styled.div`
  margin-top: 24px;
  div {
    margin: 0;
  }
`
export const PostalProcurationButton = styled.button`
  background-color: #191d20;
  border: none;
  border-radius: 8px;
  color: white;
  padding: 8px 12px;
  &:hover:not(:disabled) {
    cursor: pointer;
  }
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`

export default BelgiumPPConfirmation
